export default __webpack_public_path__ + "/dist/images/mail-reply-icon.7aed32b091f4ea97737054ddd166c829.svg";